import ModalCompareView from './modal-compare-view'

export default ModalCompareView
